export enum FreelancerSoftSkillsEvaluationStatus {
	CreatedInternally,
	CreatedExternally,
	FreelancerInvited,
	EvaluationCompleted
}
